<template>
  <q-card :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-primary text-white" inline-actions>
        {{ buy ? 'خط زمانی سفارش خرید' : 'خط زمانی سفارش فروش' }}
        <q-badge align="top" color="red" text-color="white" :label="saleNum"/>
        <template v-slot:action>
          <q-btn flat icon="close" round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section align="center">
      <q-chip square
              v-if="remainOrdered===true && !buy"
              color="pink"
              text-color="white" label="مانده سفارش" icon="tag"/>
    </q-card-section>
    <q-card-actions>
      <q-btn icon="add" round color="red" class="shadow-5" @click="showAddDialog">
        <q-tooltip>
          افزودن یک خط زمانی
        </q-tooltip>
      </q-btn>
    </q-card-actions>
    <q-card-section>
      <q-timeline color="secondary">
        <q-timeline-entry
            v-for="(item, index) in items" :key="`record_${index}`"
            :title="item.title"
            :subtitle="item.EntryDateTime"
            icon="event"
        >
          <q-chip icon="support_agent" :size="$q.screen.lt.md?'sm':'11px'"
                  square
                  :label="item.UserName">
          </q-chip>
          <q-space/>
          <div class="text-justify" v-html="replaceReturnCharacter(item.ReasonDescription)"></div>
        </q-timeline-entry>
      </q-timeline>
    </q-card-section>

    <q-dialog v-model="addDialog" :maximized="$q.screen.lt.md">
      <q-card flat :style="!$q.screen.lt.md?'width: 400px; max-width: 80vw;':''">
        <q-form @submit="onSubmit" @reset="onReset">
          <q-card-section>
            <q-select
                filled
                v-model="selectedTagName"
                label="برچسب"
                :options="lodash.sortBy(options.filter(item=> item.buy === buy), 'label')"
                option-label="label"
                option-value="id"
                use-chips
                :rules="[requiredRule]"
            />
            <q-input
                class="q-mt-xs"
                filled
                counter
                bottom-slots
                :disable="selectedTagName && selectedTagName.id===12"
                v-model="selectedReasonDescription"
                label="شرح مختصر"
                type="textarea"
            />
          </q-card-section>
          <q-card-section v-if="showFactorDay">
            <q-chip square icon="calendar_today" :label="saleDate" color="red" text-color="white">
              <q-tooltip>
                تاریخ سفارش/فاکتور
              </q-tooltip>
            </q-chip>
            <q-input v-if="!buy" :dense="$q.screen.lt.md" dir="ltr" filled v-model="endDate" mask="date"
                     :rules="['date']"
                     label="تاریخ بازپرداخت" clearable>
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                    <q-date v-model="endDate" calendar="persian">
                      <div class="row items-center justify-center">
                        <q-btn v-close-popup label="تایید" color="primary" flat/>
                        <q-btn v-close-popup @click="endDate = ToJalaliDate(new Date())" label="امروز" color="primary"
                               flat/>
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <q-input
                v-if="!buy"
                dir="ltr"
                type="number"
                filled
                v-model="factorDay"
                label="زمان بازپرداخت">
              <template v-slot:append>
                <span class="text-subtitle2">روز پس از تاریخ صدور فاکتور</span>
              </template>
            </q-input>
          </q-card-section>
          <q-card-actions>
            <q-btn color="indigo" label="ثبت رویداد" type="onsubmit" v-close-popup/>
            <q-btn flat color="red" label="انصراف" v-close-popup/>
          </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "OrderTimeLine",
  props: {
    saleNum: {
      type: Number,
      required: true
    },
    saleKind: {
      type: Number,
      default: 1
    },
    saleDate: {
      type: String,
      required: true
    },
    remainOrdered: {
      type: Boolean,
      required: true,
      default: false
    },
    withChangePayDatePermission: {
      type: Boolean,
      default: false
    },
    buy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      disabledText: false,
      addDialog: false,
      endDate: '',
      options: this.$store.state.timeLineOptions,
      items: [],
      selectedTagName: null,
      selectedReasonDescription: '',
      factorDay: 0,
      showFactorDay: false
    }
  },
  methods: {
    ...mapActions({
      setOrderTrace: 'Orders/setOrderTrace',
      setBuyOrderTrace: 'Buys/setBuyOrderTrace',
      getOrderTrace: 'Orders/getOrderTimeLine',
      getBuyTrace: 'Buys/getBuyOrderTrace'
    }),
    replaceReturnCharacter(str) {
      if (str) {
        return str.replace(/(\\r)*\\n/g, '<br>')
      } else {
        return ''
      }
    }
    ,
    showAddDialog() {
      this.addDialog = true;
    }
    ,
    requiredRule(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    }
    ,
    onSubmit() {
      if (!this.buy) {
        if (this.selectedTagName.id === 6 && this.remainOrdered === true) {
          this.$q.notify({
            message: `امکان آرشیو کردن مانده سفارش وجود ندارد`,
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        } else if (this.selectedTagName.id === 11 && (!this.selectedReasonDescription || this.selectedReasonDescription === '' || this.selectedReasonDescription.length <= 15)) {
          this.$q.notify({
            message: `ثبت توضیحات برای بچسب الزامی، درخواست حذف توسط سیستم برگشت داده شد`,
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        } else if (this.selectedTagName.id === 12 && (this.endDate === '')) {
          this.$q.notify({
            message: `زمان بازپرداخت مشخص نشده است`,
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        } else if (this.selectedTagName.id === 14 && (!this.selectedReasonDescription || this.selectedReasonDescription === '' || this.selectedReasonDescription.length <= 15)) {
          this.$q.notify({
            message: `درج علت برگشت الزامی است`,
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        } else {
          this.setOrderTrace({
            UserName: this.$store.state.userName,
            Sale_Num: this.saleNum,
            title: this.selectedTagName,
            ReasonDescription: this.selectedTagName.id === 12 ? (this.factorDay === 0 ? `سفارش نقدی است` : `نحوه بازپرداخت سفارش ${this.factorDay} روز پس از تاریخ صدور فاکتور می باشد`) : this.selectedReasonDescription,
            factorDay: this.factorDay
          }).then((res) => {
            this.items.unshift(res.data[0])
            this.$emit('refresh-data', {type: 'trace', data: res.data[0]})
            this.addDialog = false;
            this.onReset()
          })
        }
      } else if (this.buy) {
        this.setBuyOrderTrace({
          UserName: this.$store.state.userName,
          Sale_Num: this.saleNum,
          Sale_Kind: this.saleKind,
          title: this.selectedTagName,
          ReasonDescription: this.selectedReasonDescription,
          factorDay: this.factorDay
        }).then((res) => {
          this.items.unshift(res.data[0])
          this.$emit('refresh-data', {type: 'trace', data: res.data[0]})
          this.addDialog = false;
          this.onReset()
        })
      }
    }
    ,
    onReset() {
      this.selectedReasonDescription = ''
      this.selectedTagName = null
    }
  }
  ,
  watch: {
    selectedTagName: function (val) {
      if (val && val.id === 12) {
        this.showFactorDay = true
      } else {
        this.showFactorDay = false
      }
    }
    ,
    factorDay: function (value) {
      if (value && value > 0) {
        this.endDate = this.ToJalaliDateByDayAdd(this.saleDate, value)
        this.selectedReasonDescription = `نحوه بازپرداخت سفارش ${this.factorDay} روز پس از تاریخ صدور فاکتور می باشد`
      } else {
        this.selectedReasonDescription = ""
      }
    }
    ,
    endDate: function (val) {
      let duration = this.DiffToJalaliDate(this.saleDate, val)
      if (Math.round(duration) >= 0) {
        this.factorDay = Math.round(duration)
      } else {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'تاریخ وارد شده کوچکتر از تاریخ سفارش/فاکتور است'
        })
      }
    }
  }
  ,
  created() {
    if (!this.buy) {
      this.getOrderTrace(this.saleNum).then((res) => {
        this.items = res.data

        if (this.withChangePayDatePermission) {
          // can_change_pay_date
          if (!this.$store.state.roles.some(v => ['admin', 'can_change_pay_date'].includes(v))) {
            const foundedIndex = this.options.findIndex(item => item.id === 12)
            this.$delete(this.options, foundedIndex)
          }
        }
      })
    } else if (this.buy) {
      this.getBuyTrace({
        Buy_Num: this.saleNum,
        Buy_Kind: this.saleKind
      }).then((res) => {
        this.items = res
        if (this.items === undefined) this.items = []
      })
    }
  }
}
</script>

<style scoped>

</style>